import * as React from 'react';
import clsx from 'clsx';

import { LocationShape, StartTime } from 'lib/util/productShape';
import { applyRelativeTimeOffset } from 'lib/util/applyRelativeTimeOffset';
import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';

import styles from '../ProductDetailsView.module.css';
import baseStyles from '../../base.module.css';

interface Props {
  startTime?: StartTime;
  locations: LocationShape[];
}

export const LocationList = ({ startTime, locations }: Props) => {
  return (
    <>
      {locations.map((location) => {
        const dedicatedStartTimeItem = location.dedicatedStartTimeInfoItems.find(
          (item) => item.timeSlotKey === startTime?.timeSlotKey
        );

        let timeRelative = location.timeRelative;
        if (dedicatedStartTimeItem && dedicatedStartTimeItem.timeRelative) {
          timeRelative = dedicatedStartTimeItem.timeRelative;
        }
        const timeDescription = timeRelative
          ? applyRelativeTimeOffset(startTime?.hhMm || '0:00', timeRelative)
          : '';

        return (
          <div key={location.name} className={styles['overview__content__item__scheds__item']}>
            <p className={styles['overview__content__item__scheds__item__time']}>
              {timeDescription}
            </p>
            <div className={styles['overview__content__item__scheds__item__point']}>
              <p className={baseStyles['color-bg--black']}></p>
              <p className={baseStyles['color-bg--black']}></p>
            </div>
            <div className={styles['overview__content__item__scheds__item__info']}>
              <a
                href={`https://www.google.com/maps/search/?api=1&query_place_id=${location.googlePlaceID}&query=${location.name}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className={styles['overview__content__item__scheds__item__info__ttl']}>
                  {location.name}
                </p>
              </a>
              <p className={clsx('overview__content__item__scheds__item__info__desc', 'newline')}>
                <LinkableTextArea>{location.description}</LinkableTextArea>
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
};
